/*@ngInject*/
const ActionsMediator = function (makeApplicationRepository, modificationsRepository,
                                                 modifySubmissionRepository, markSubmissionLostRepository,
                                                 clearSubmissionRepository, declineSubmissionRepository,
                                                 rejectSubmissionRepository, reactivateSubmissionRepository,
                                                 reevaluateSubmissionRepository, createQuoteRepository,
                                                 getQuotableProductTemplatesRepository, changeProductsRepository,
                                                 updateStatusReasonRepository, submitModificationsRepository,
                                                 discardModificationsRepository, referSubmissionRepository,
                                                 clearReadySubmissionRepository,
                                                 createProposalRepository, checkClearanceRepository,
                                                 copySubmissionRepository,
                                                 referralRepository, splitSubmissionRepository,
                                                 acknowledgeModificationsRepository, rewriteSubmissionRepository,
                                                 resubmitSubmissionRepository, renewalRepository,
                                                 disableAutomationRepository) {

    this.makeApplication = function (submissionId) {
        return makeApplicationRepository.makeApplication(submissionId);
    };

    this.submitModifications = function (submissionId) {
        return submitModificationsRepository.submitModifications(submissionId);
    };

    this.markAsLost = function (submissionId, reason, detail) {
        return markSubmissionLostRepository.markAsLost(submissionId, reason, detail);
    };

    this.discardModifications = function (submissionId) {
        return discardModificationsRepository.discardModifications(submissionId);
    };

    this.markSubmissionClear = function (submissionId) {
        return clearSubmissionRepository.markSubmissionClear(submissionId, true);
    };

    this.acknowledgeModifications = function (submissionId) {
        return acknowledgeModificationsRepository.acknowledgeModifications(submissionId);
    };

    this.markSubmissionNotClear = function (submissionId, reason, detail) {
        return clearSubmissionRepository.markSubmissionClear(submissionId, false, reason, detail);
    };

    this.markSubmissionClearReady = function (submissionId, reason, detail) {
        return clearReadySubmissionRepository.markSubmissionClearReady(submissionId, reason, detail);
    };

    this.revertToClear = function (submissionId, reason, detail) {
        return clearSubmissionRepository.revertToClear(submissionId, reason, detail);
    };

    this.copySubmission = function (submissionId, copyOptions) {
        return copySubmissionRepository.copySubmission(submissionId, copyOptions);
    };

    this.handleCheckClearance = function (submissionId) {
        return checkClearanceRepository.checkClearance(submissionId);
    };

    this.decline = function (submissionId, primaryReason, comments) {
        return declineSubmissionRepository.decline(submissionId, primaryReason, comments);
    };

    this.reject = function (submissionId, primaryReason, comments) {
        return rejectSubmissionRepository.reject(submissionId, primaryReason, comments);
    };

    this.reactivate = function (submissionId) {
        return reactivateSubmissionRepository.reactivate(submissionId);
    };

    this.reevaluate = function (submissionId) {
        return reevaluateSubmissionRepository.reevaluate(submissionId);
    };

    this.createQuote = function (submissionId, productId) {
        return createQuoteRepository.createQuote(submissionId, productId);
    };

    this.getQuotableProductTemplates = function (quoteId) {
        return getQuotableProductTemplatesRepository.getQuotableProductTemplates(quoteId);
    };

    this.changeProducts = function (submissionId, productShortNames) {
        return changeProductsRepository.changeProduct(submissionId, productShortNames);
    };

    this.updateStatusReason = function (submissionId, reason, detail) {
        return updateStatusReasonRepository.updateStatusReason(submissionId, reason, detail);
    };

    this.modifySubmission = function (submissionId) {
        return modifySubmissionRepository.modifySubmission(submissionId);
    };

    this.referSubmission = function (submissionId, primaryReason, underwriterId, comments) {
        return referSubmissionRepository.referSubmission(submissionId, primaryReason, underwriterId, comments);
    };

    this.retractReferral = function (submissionId, primaryReason, comments) {
        return referralRepository.retractReferral(submissionId, primaryReason, comments);
    };

    this.getReferralClearanceType = function (submissionId) {
        return referralRepository.getReferralClearanceType(submissionId);
    };

    this.clearReferral = function (submissionId, detail, doDecline) {
        return referralRepository.clearReferral(submissionId, detail, doDecline);
    };

    this.splitSubmission = function (submissionId, productShortNames) {
        return splitSubmissionRepository.splitSubmission(submissionId, productShortNames);
    };

    this.rewriteSubmission = function (submissionId, reason, detail, effectiveDate, expirationDate, copyOptions) {
        return rewriteSubmissionRepository.rewriteSubmission(submissionId, reason, detail, effectiveDate, expirationDate, copyOptions);
    };

    this.resubmitSubmission = function (submissionId) {
        return resubmitSubmissionRepository.resubmit(submissionId);
    };

    this.submitRenewal = function (submissionId) {
        return renewalRepository.submitRenewal(submissionId);
    };

    this.submitNonRenewal = function (submissionId, primaryReason, comments) {
        return renewalRepository.submitNonRenewal(submissionId, primaryReason, comments);
    };

    this.retractNonRenewal = function (submissionId) {
        return renewalRepository.retractNonRenewal(submissionId);
    };

    this.flagForNonRenewal = function (submissionId, primaryReason, comments) {
        return renewalRepository.flagForNonRenewal(submissionId, primaryReason, comments);
    };

    this.clearNonRenewalFlag = function (submissionId) {
        return renewalRepository.clearNonRenewalFlag(submissionId);
    };

    this.disableAutomation = function (submissionId) {
        return disableAutomationRepository.disableAutomation(submissionId);
    };

    this.markExpired = function (submissionId, reason, detail) {
        return renewalRepository.markExpired(submissionId, reason, detail);
    };

    this.markRenewed = function (submissionId) {
        return renewalRepository.markRenewed(submissionId);
    };

    this.markNonRenewed = function (submissionId, reason, detail) {
        return renewalRepository.markNonRenewed(submissionId, reason, detail);
    };

    this.declineReferral = function (submissionId, comments) {
        return referralRepository.declineReferral(submissionId, comments, true);
    };
};

angular.module('gw-um-submission')
    .service('actionsMediator', ActionsMediator);
